import {
    Container,
    Box,
    Typography,
    List,
    ListItem,
    ListItemText,
} from '@mui/material';
import FragenPage from './FragenPage';
import { useState, useEffect } from 'react';
import { getAllFromCache } from '../ResponseHandlers/indexedDBHelper';

// const IndexedDBUtils = {
//     async openDB() {
//         return new Promise((resolve, reject) => {
//             const request = indexedDB.open('QuestionDB', 1);

//             request.onupgradeneeded = (event) => {
//                 const db = event.target.result;
//                 if (!db.objectStoreNames.contains('starredQuestions')) {
//                     db.createObjectStore('starredQuestions', { keyPath: 'id' });
//                 }
//             };

//             request.onsuccess = () => resolve(request.result);
//             request.onerror = () => reject(request.error);
//         });
//     },

//     async getstarredQuestions() {
//         const db = await this.openDB();
//         return new Promise((resolve, reject) => {
//             const transaction = db.transaction(
//                 ['starredQuestions'],
//                 'readonly',
//             );
//             const store = transaction.objectStore('starredQuestions');
//             const request = store.getAll();
//             // resolve to extract the data
//             request.onsuccess = () => resolve(request.result);
//             request.onerror = () => reject(request.error);
//         });
//     },
// };

// const questionData = await IndexedDBUtils.getstarredQuestions();

function RecordsPage() {
    const [questions, setQuestions] = useState([]);

    const fetchQuestions = async () => {
        // const data = await IndexedDBUtils.getstarredQuestions();
        const data = await getAllFromCache('starredQuestions');
        setQuestions(data);
    };

    // Fetch data when component mounts
    useEffect(() => {
        fetchQuestions();
    }, []);

    return (
        <Container>
            {questions.length > 0 ? (
                <FragenPage questions={questions} />
            ) : (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignContent: 'flex-start',
                    }}
                >
                    <Typography
                        variant="body1"
                        sx={{ mt: 2, ml: 5, textAlign: 'left' }}
                        gutterBottom
                    >
                        Fragen können automatisch oder manuell aufgezeichnet
                        werden:
                    </Typography>
                    <List sx={{ mt: 2, ml: 5, textAlign: 'left' }}>
                        <ListItem>
                            <ListItemText primary="1. Wenn Sie eine falsche Antwort auswählen, wird die Frage automatisch aufgezeichnet." />
                        </ListItem>
                        <ListItem>
                            <ListItemText primary="2. Sie können eine Frage auch manuell aufzeichnen." />
                        </ListItem>
                    </List>
                </Box>
            )}
        </Container>
    );
}
export default RecordsPage;
